import * as React from 'react'
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="30"
    viewBox="0 0 32 30"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1634_2862)">
      <path
        d="M16.3847 23.1178L17.4346 21.8157C21.3848 24.2165 26.2869 23.7761 29.2629 20.086C32.4961 16.0771 31.2179 11.0031 27.1937 7.78229L17.4635 0L12.4778 6.18387L14.6981 6.94784L13.666 8.22914C9.71569 5.82831 4.80076 6.28477 1.82479 9.97491C-1.40842 13.9838 -0.117384 19.0417 3.90685 22.2626L13.5775 30L18.5503 23.8305L16.3831 23.1178H16.3847ZM11.0244 11.402C13.0309 8.91303 16.6853 8.51583 19.1838 10.5147C21.6823 12.5135 22.081 16.1524 20.0745 18.6429C18.068 21.1318 14.4136 21.529 11.9151 19.5302C9.41665 17.5314 9.01792 13.8909 11.0244 11.402Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1634_2862">
        <rect width="31.0909" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export { SvgComponent as MydraIcon }
